import { render } from "./base-confirm-modal.vue?vue&type=template&id=d77aefc2&ts=true"
import script from "./base-confirm-modal.vue?vue&type=script&lang=ts"
export * from "./base-confirm-modal.vue?vue&type=script&lang=ts"

import "./base-confirm-modal.vue?vue&type=style&index=0&id=d77aefc2&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__